import request from '@/utils/request'

// 조회
export function getWorkerParticipationProcedure(params, isProgress) {
  return request({
    url: `/api/getWorkerParticipationProcedure`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' }
  })
}
// 예시
export function getWorkerParticipationProcedureSample(isProgress) {
  return request({
    url: `/api/getWorkerParticipationProcedureSample`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    Notify: { use: isProgress, apitype: 'searched' }
  })
}
// 저장
export function saveWorkerParticipationProcedure(params, isProgress) {
  return request({
    url: `/api/saveWorkerParticipationProcedure`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'saved' }
  })
}
// 삭제
export function deleteWorkerParticipationProcedure(params, isProgress) {
  return request({
    url: `/api/deleteWorkerParticipationProcedure`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'deleted' }
  })
}
// 출력
export function getWorkerParticipationProcedureReport (params, isProgress) {
  let responseType = "blob"
  return request({
    url: '/api/getWorkerParticipationProcedureReport',
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    responseType: responseType,
    Notify: { use: isProgress, apitype: 'searched' }
  })
}